


































































import Vue from "vue";

export default Vue.extend({
    props: {
        isTypeButton: {
            type : Boolean,
            required: false,
            default: false
        },
        isLoading: {
            type: Boolean,
            required: true
        },
        loadingLabel: {
            type: String,
            required: false,
            default: null
        },
        defaultLabel: {
            type: String,
            required: false,
            default: null
        },
        isIconPublish: {
            type: Boolean,
            required: false,
            default: false
        },
        isIconPrevious: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        activeLabel: function(): string {
            return this.defaultLabel;
        }
    },
    methods: {
        handleClick: function (event: MouseEvent): boolean | void {
            if (this.isLoading) {
                event.preventDefault();
                return false;
            }

            this.$emit("buttonclicked");
        }
    }
});
